// Splits on semicolons or newlines (a pasted "Enter") - the only separators tags-input commits
// a chip on (see COMMIT_KEYS in tags-input.component.ts). Spaces and commas are left alone so a
// tag's own text (e.g. "New York", "Rev, 2") isn't torn apart.
const TAG_SEPARATOR_PATTERN = /[;\n]+/;

/** Splits a delimited string (e.g. `"a;b;c"`) into trimmed, non-empty tag candidates. */
export function splitTagList(text: string): string[] {
  return text
    .split(TAG_SEPARATOR_PATTERN)
    .map(part => part.trim())
    .filter(part => part.length > 0);
}

/** Trims a single tag candidate and strips a trailing separator left over from a commit key. */
export function normalizeTagCandidate(text: string): string {
  return text.trim().replace(/;$/, '').trim();
}

/** Joins tags back into the single delimited string the `classification` field stores. */
export function joinTags(tags: string[]): string {
  return tags.join('; ');
}
